import { useState, useEffect, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Utils } from 'utils';

import Api from 'service/api';

const MIDIA_URL = process.env.REACT_APP_MIDIA_URL;
const setPrefixMidia = (midia) => `${MIDIA_URL}/${midia}`;

const useModalViewCommunication = ({ viewCommunicationId, onClose }) => {
    const [loadingPage, setLoadingPage] = useState(true);
    const [transitionIn, setTransitionIn] = useState(false);
    const [comunicacao, setComunicacao] = useState([]);
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');
    const [nota, setNota] = useState(null);
    const [rateAvaliable, setRateAvaliable] = useState(false);
    const [messagemAgradecimento, setMessagemAgradecimento] = useState('');

    const handleChangeNota = (e) => {
        if (!rateAvaliable) return;
        setNota(e.target.innerText);
    };

    const handleSaveAvaliacao = async () => {
        if (!nota) {
            setMessageAlert('Selecione uma nota');
            setOpenAlert(true);
            return;
        }
        const avaliacao = {
            nota,
        };
        setLoadingPage(true);
        await Api.post(`comunicacao-altum/save-rate/${viewCommunicationId}`, avaliacao)
            .then(async (response) => {
                console.log('dados:', response.data);
                // await getData();
                setMessagemAgradecimento('Avaliação enviada com sucesso!');
                setTimeout(() => {
                    setTransitionIn(true);
                    scrollToBottom();
                }, 100);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setLoadingPage(false);
            });
    };

    const containerRef = useRef(null);
    const { t: translate } = useTranslation();

    const currentLang = window.localStorage.i18nextLng;

    const getData = useCallback(async () => {
        if (!viewCommunicationId) return;
        try {
            await Api.get(`/comunicacao-altum/view/${viewCommunicationId}`)
                .then((response) => {
                    setComunicacao(response.data.listagem);
                    if (response.data.listagem) {
                        setNota(response.data.listagem.avaliacao?.ciaa_nota_avaliacao ?? null);
                        setRateAvaliable(!response.data.listagem.avaliacao?.ciaa_nota_avaliacao);
                    } else {
                        setNota(null);
                        setRateAvaliable(false);
                    }
                    setLoadingPage(false);
                    setTimeout(() => {
                        setTransitionIn(true);
                        scrollToBottom();
                    }, 100);

                    sendViewNotify(viewCommunicationId);
                })
                .catch((error) => {
                    setLoadingPage(true);
                    setTimeout(() => {
                        setTransitionIn(true);
                    }, 100);
                    console.log(error);
                });
        } catch (error) {
            if (Api.isCancel(error)) {
                setTransitionIn(true);
            } else {
                setTransitionIn(true);
                throw error;
            }
        }
    }, [viewCommunicationId]);

    useEffect(() => {
        const loadData = async () => {
            await getData();
        };
        loadData();
    }, [getData]);

    const scrollToBottom = () => {
        if (containerRef.current) {
            containerRef.current.scrollTop = containerRef.current.scrollHeight;
        }
    };

    const sendViewNotify = async (comunicacaoId) => {
        await Api.post(`notificacao/visualizacao-comunicacao`, {
            comunicacao_id: comunicacaoId,
        }).catch((err) => {
            console.log(err);
        });
    };

    const hadleGoback = () => {
        if (onClose) onClose();
    };

    const handleGetFileName = (fileUrl) => {
        if (!fileUrl) return '';
        const frag = fileUrl.split('?');
        const pathFrag = frag[0].split('/');
        return pathFrag[5] || pathFrag[pathFrag.length - 1]; // Fallback
    };

    return {
        transitionIn,
        loadingPage,
        comunicacao,
        currentLang,
        hadleGoback,
        setPrefixMidia,
        translate,
        Utils,
        setLoadingPage,
        comunicacaoId: viewCommunicationId,
        openAlert,
        messageAlert,
        setOpenAlert,
        handleGetFileName,
        containerRef,
        rateAvaliable,
        handleChangeNota,
        nota,
        handleSaveAvaliacao,
        messagemAgradecimento,
    };
};

export default useModalViewCommunication;
